import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { EMAIL_ID_PATTERN, UK_PHONE_NUMBER_PATTERN } from '../../utils/regex.js';
import { LimitedKapAddress } from './LimitedKapAddress.js';
export class KapDetails extends BaseMessage {
    kapId;
    title;
    firstName;
    middleName;
    surname;
    nationalityIso;
    dob;
    address;
    nationality;
    emailId;
    phoneNumber;
}
__decorate([
    Field.string({
        description: 'Kap Id',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], KapDetails.prototype, "kapId", void 0);
__decorate([
    Field.string({
        description: 'Title of the name of the Kap',
    }),
    __metadata("design:type", String)
], KapDetails.prototype, "title", void 0);
__decorate([
    Field.string({
        description: 'Firstname of the Kap',
    }),
    __metadata("design:type", String)
], KapDetails.prototype, "firstName", void 0);
__decorate([
    Field.string({
        description: 'Middlename of the Kap',
    }),
    __metadata("design:type", String)
], KapDetails.prototype, "middleName", void 0);
__decorate([
    Field.string({
        description: 'Surname of the Kap',
    }),
    __metadata("design:type", String)
], KapDetails.prototype, "surname", void 0);
__decorate([
    Field.string({
        description: 'Nationality of the Kap',
        required: false,
    }),
    __metadata("design:type", String)
], KapDetails.prototype, "nationalityIso", void 0);
__decorate([
    Field.string({
        description: 'Dob of the Kap',
    }),
    __metadata("design:type", String)
], KapDetails.prototype, "dob", void 0);
__decorate([
    Field.message({
        description: 'Address of the organisation',
    }),
    __metadata("design:type", LimitedKapAddress)
], KapDetails.prototype, "address", void 0);
__decorate([
    Field.string({
        description: 'Nationality of the Kap',
    }),
    __metadata("design:type", String)
], KapDetails.prototype, "nationality", void 0);
__decorate([
    Field.string({
        description: 'Email Id of an individual',
        required: false,
        maxLength: 80,
        pattern: EMAIL_ID_PATTERN,
    }),
    __metadata("design:type", String)
], KapDetails.prototype, "emailId", void 0);
__decorate([
    Field.string({
        description: 'Phone Number of an individual',
        required: false,
        maxLength: 11,
        pattern: UK_PHONE_NUMBER_PATTERN,
    }),
    __metadata("design:type", String)
], KapDetails.prototype, "phoneNumber", void 0);
//# sourceMappingURL=KapDetails.js.map